import React from 'react';
import { CTAButton, scrollToPricing } from './CTAButton';
import { TrustBar } from './TrustBar';
import { productImage } from '../data/content';
export function FinalCTA() {
  return <section className="bg-brand-navy px-4 py-4 text-center text-white sm:px-6 sm:py-5" aria-labelledby="final-heading" data-id="element-43" data-mp="c6iultloo175">
      <h2 id="final-heading" className="mb-1.5 text-[19px] font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-44" data-mp="84e2izavvcmm">
        Un’Ultima Occasione
      </h2>
      <p className="mx-auto mb-1.5 max-w-xl text-[12px] font-medium leading-snug text-white/85 sm:text-sm" data-id="element-45" data-mp="h6dh7kyfe4me">
        I tuoi giocatori meritano lezioni costruite con metodo, non sessioni improvvisate perché non
        hai avuto il tempo di prepararle. Smetti di perdere ore ogni settimana tra pianificazioni,
        esercizi, progressioni, valutazioni e programmi. Smetti di cercare materiale in decine di
        libri, PDF, video e appunti. Inizia a lavorare con un sistema professionale già pronto,
        progettato per aiutarti a preparare ogni sessione in pochi minuti e offrire un livello di
        coaching ancora più professionale.
      </p>
      <p className="mx-auto mb-2.5 max-w-xl text-[12px] font-bold leading-snug sm:text-sm" data-id="element-46" data-mp="2h5u4cvkwiwg9">
        Con PADEL MASTER PRO™ avrai finalmente tutto ciò di cui hai bisogno in un’unica soluzione.
      </p>
      <button type="button" onClick={scrollToPricing} className="mb-2.5 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Vai alla sezione di acquisto" data-id="element-47" data-mp="2qzui1lu91a0l">
        <img src={productImage} alt="PADEL MASTER PRO — sistema completo 6-in-1 con 5 bonus premium" className="mx-auto w-full max-w-[200px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-48" data-mp="34tc3jc6hwwt9" />
      </button>
      <div className="mx-auto mb-2.5 max-w-sm rounded-lg border border-brand-green/60 bg-white/5 p-2.5" data-id="element-49" data-mp="3istrjpbyw61k">
        <p className="font-heading text-[12px] font-extrabold uppercase sm:text-sm" data-id="element-50" data-mp="1jntq7q1unrw8">
          🎾 PADEL MASTER PRO™
        </p>
        <p className="text-[11px] font-bold text-white/85" data-id="element-51" data-mp="1eqjsln4b49xb">
          Sistema Completo 6-in-1 + 5 Bonus Premium
        </p>
        <p className="mt-1 text-[11px] font-semibold text-white/60" data-id="element-52" data-mp="1shydy0losn7j">
          Prezzo di Listino: <span className="line-through" data-id="element-53" data-mp="1nodqh2hpzbml">97€</span>
        </p>
        <p className="font-heading text-xl font-extrabold uppercase leading-tight text-brand-green sm:text-2xl" data-id="element-54" data-mp="22e1pty6cc07o">
          Oggi Solo: 27€
        </p>
      </div>
      <div className="mx-auto mb-1.5 max-w-md" data-id="element-55" data-mp="1xi48bojccntb">
        <CTAButton data-id="element-56" data-mp="2behq6yrser8b">🚀 SÌ! VOGLIO PADEL MASTER PRO™ ORA</CTAButton>
      </div>
      <p className="mb-1.5 text-[10.5px] font-bold text-white/85 sm:text-xs" data-id="element-57" data-mp="27debiflh718o">
        Accesso Immediato • Consegna Istantanea via Email
      </p>
      <TrustBar data-id="element-58" data-mp="h207m4hw8fa0" />
    </section>;
}